import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingComponent } from '@app/shared/components/loading/loading.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  exports: [LoadingComponent],
  declarations: [LoadingComponent],
})
export class LoadingModule {}
